var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "align-h": "end" } },
    [
      _c(
        "b-col",
        { staticClass: "pr-lg-2", attrs: { lg: "12", md: "12" } },
        [
          _c("base-input", {
            attrs: { label: _vm.$t("report.reason") },
            model: {
              value: _vm.report.reason,
              callback: function($$v) {
                _vm.$set(_vm.report, "reason", $$v)
              },
              expression: "report.reason"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "pr-lg-2", attrs: { lg: "12", md: "12" } },
        [
          _c("base-textarea", {
            attrs: { label: _vm.$t("report.history"), rows: 5, maxRows: 12 },
            model: {
              value: _vm.report.history,
              callback: function($$v) {
                _vm.$set(_vm.report, "history", $$v)
              },
              expression: "report.history"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "pr-lg-2", attrs: { lg: "12", md: "12" } },
        [
          _c("base-textarea", {
            attrs: { label: _vm.$t("report.diagnosis"), rows: 5, maxRows: 12 },
            model: {
              value: _vm.report.diagnosis,
              callback: function($$v) {
                _vm.$set(_vm.report, "diagnosis", $$v)
              },
              expression: "report.diagnosis"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "pr-lg-2", attrs: { lg: "12", md: "12" } },
        [
          _c("base-textarea", {
            attrs: { label: _vm.$t("report.treatment"), rows: 5, maxRows: 12 },
            model: {
              value: _vm.report.treatment,
              callback: function($$v) {
                _vm.$set(_vm.report, "treatment", $$v)
              },
              expression: "report.treatment"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3907006a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3907006a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/professional/report.vue
// module id = 3900
// module chunks = 30